
import { defineComponent, onMounted, PropType } from "vue";

export default defineComponent({
  name: "PlayerJsAdapter",
  props: {
    videoEl: { type: Object as PropType<HTMLVideoElement>, required: true }
  },
  setup(props) {
    onMounted( async () => {
      if (!props.videoEl) return;

      if (!window.playerjs) {
        await new Promise((resolve, reject) => {
        console.log("Adding script tag")
          const script = document.createElement("script");
          script.src = "//cdn.embed.ly/player-0.1.0.min.js";
          script.async = true;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      // Wait for Player.js to load
      const waitForPlayerjs = () =>
        new Promise<void>((resolve) => {
          if ((window as any).playerjs) return resolve();
          const interval = setInterval(() => {
            if ((window as any).playerjs) {
              clearInterval(interval);
              resolve();
            }
          }, 50);
        });

      waitForPlayerjs().then(() => {
        const playerjs = new window.playerjs.HTML5Adapter((props.videoEl as any)?.value);
        playerjs.ready();
      });
    });
  }
});
